const URL_MY_ACCOUNT = "https://tbzptw-nu.myshopify.com/account";
const GANBARU_SITE = [
    "app-ganbaru-web-stage.azurewebsites.net",
    "app.ganbarumethod.com",
];
function getCookie(name) {
    const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name, value, days = 30) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
        value
    )}; expires=${expires}; path=/`;
}

document.addEventListener("DOMContentLoaded", function () {
    const path = window.location.pathname;
    const match = path.match(/\/ref\/([\w-]+)/);
    const urlParams = new URLSearchParams(window.location.search);
    const params = new URLSearchParams(window.location.search);

    let successUrl = params.get("successUrl");
    let uuid = params.get("uuid");

    if (match && !urlParams.has("ref")) {
        const ref = match[1];
        setCookie("ref", ref);

        const cleanPath = path.replace(/\/ref\/[\w-]+$/, "") || "/";
        const search = window.location.search;
        const newUrl = `${cleanPath}${
            search ? search + "&" : "?"
        }ref=${encodeURIComponent(ref)}`;
        window.location.replace(newUrl);
        return;
    }

    let ref = urlParams.get("ref");
    let storedRef = getCookie("ref");
    let visitUrl = window.location.href;
    let storedVisitUrl = getCookie("visit_url");
    if (!storedVisitUrl && visitUrl) {
        setCookie("visit_url", visitUrl);
    }
    if (!storedRef && ref) {
        setCookie("ref", ref);
        storedRef = ref;
    }
    document.querySelectorAll("a").forEach((link) => {
        if (GANBARU_SITE.some((domain) => link.href.includes(domain))) {
            try {
                const url = new URL(link.href);
                if (storedRef) {
                    url.searchParams.set("ref", storedRef);
                }
                if (successUrl) {
                    url.searchParams.set("successUrl", successUrl);
                } else {
                    url.searchParams.set("successUrl", URL_MY_ACCOUNT);
                }
                if (uuid) {
                    url.searchParams.set("uuid", uuid);
                }
                link.href = url.toString();
            } catch (e) {
                console.error("Invalid URL:", link.href);
            }
        }
    });
});
(async function () {
    try {
        const ref = getCookie("ref");

        const visitUrl = getCookie("visit_url");

        if (!ref && !visitUrl) return;

        const cartResponse = await fetch("/cart.js");
        if (!cartResponse.ok) {
            throw new Error("Error: " + cartResponse.status);
        }

        const cart = await cartResponse.json();
        console.log(cart);
        const existingAttributes = cart.attributes || {};

        const updates = {};

        if (ref && !existingAttributes.ref) {
            updates.ref = ref;
        }

        if (!existingAttributes.visit_url) {
            updates.visit_url = visitUrl;
        }

        if (Object.keys(updates).length === 0) return;

        const updateResponse = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
                attributes: {
                    ...existingAttributes,
                    ...updates,
                },
            }),
        });

        if (!updateResponse.ok) {
            throw new Error("Error: " + updateResponse.status);
        }
    } catch (error) {
        console.error("Error cart attributes:", error);
    }
})();
